import { RootState } from 'reducers';

export const selector = (state: RootState) => state.components.orderSubmittedModal;
